<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-card pa-0> 
              <v-toolbar dark flat dense cad color="primary">
                <v-toolbar-title class="subheading">Form User</v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="form-btn">
                    <v-btn v-if="!isUpdate" @click="save(isUpdate)" v-bind:loading="loading" outline>Create</v-btn>
                    <v-btn v-else @click="save(isUpdate)"  v-bind:loading="loading" outline>Update</v-btn>                                                                                        
                </div>
              </v-toolbar>
              <v-card-text class="">              
                <v-form v-model="valid">                      
                  <v-text-field box
                      label="Username"
                      name="username"                              
                      v-model="formModel.username"
                      v-validate="'required'"
                      data-vv-name="username"  
                      @keyup="setEmail()"
                      :error-messages="errors.collect('username')"  
                      required
                  ></v-text-field>

                  <v-text-field box
                    v-validate="'required|email'"
                    v-model="formModel.email"
                    :error-messages="errors.collect('email')"
                    label="E-mail"
                    data-vv-name="email"
                    required
                  ></v-text-field>  

                  <v-text-field          
                    box                    
                    v-model="formModel.password"
                    :error-messages="errors.collect('password')"
                    label="Password"
                    data-vv-name="password"
                    type="password"
                    required
                  ></v-text-field>  
                                     
                  <v-text-field box
                      label="Phone Number"
                      name="phone"                              
                      v-model="formModel.phone"
                      v-validate="'required'"
                      data-vv-name="phone"     
                      :error-messages="errors.collect('phone')"  
                      required
                  ></v-text-field>
                      
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                  
        </v-layout>          
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/models/User';    
import direct from '@/util/directives';

var model = new Model();

export default {
    directives : direct, 
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        panel:[],
        panelId:[],
        isUpdate:false,
        code: null,
        name:null,
        type: null, 
        swithStatus: false,
        formModel: {
          id      : null,  
          email    : null,          
          username : null,
          password : null,          
          name : null,
          phone : null,
          address : null,          
          status : 10,
          trial : null,          
          userAreas : []
        },
        
        statusSwitch :false,
        //countries: Countries,
        balance: [],    
        valid: true,
        loading : false,
        alert : null,
        idx : 0
    }),
    computed:{
      filterKompetisi(){
          let result = [];
          this.kompetisis.forEach((item)=>{
             let index = this.formModel.userAreas.findIndex(function(i){return i.kompetisi_id == item.id;});            
             if(index<0){
               result.push(item);
             }
          });   
          return result;
      },
    },
    watch:{      
      kompetisi_id(newVal){
        if(newVal){
          var ketemu = false;
          this.formModel.userAreas.forEach(item=>{
            if(item.kompetisi_id === newVal) ketemu = true;
          });
          if(!ketemu){
            this.newDtl({kompetisi_id : newVal, id:null, tingkat:this.tingkatKompetisi(newVal), 
              area:null, areaName:null,
              area_id:this.areaKompetisi(newVal)}, this.idx);                     
          }
          var ctx=this; setTimeout(function(){ctx.kompetisi_id = null;},500);
        }
      },
    },
    created () {
      this.$watch(['formModel','trial'].join('.'), (val)=>{ if(val){
          this.$refs.date.save(val);
          this.formModel.dateV = this.$moment(val).format('DD-MM-YYYY');
      }});
    },    
    mounted () {this.init();}, 
    methods : {
        init(){
            //if(this.$route.query.id){
            this.isUpdate  = true; this.loading= true;
            model.profile().then(res => {                      
                Object.assign(this.formModel, res.data === null ? {}:res.data);
                //this.formModel.userArea.forEach((item,i)=>{this.newDtl(item, i);});
                this.loading=false;
            });                                               
            //}            
            this.$validator.localize('en', this.dictionary);       
        },
        
        setEmail(){
            if(!this.isUpdate){
                this.formModel.email = this.formModel.username + '@sangkilsoft.com';
            }
        },                
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = this.$moment().valueOf();
            this.formModel.info = null;            
            if( !this.errors.any() ) { this.loading=true;
                var res = isUpdate ? await model.updateProfile(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){  
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
                this.loading=false;
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },       
                
    }
}
</script>
